/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  AddCompaniesRequest,
  BulkSetItemDoneRequest,
  CompanyListDetail,
  CompanyListSummary,
  CreateListRequest,
  CreateListResponse,
  MoveCompaniesRequest,
  OptimizeRouteRequest,
  OptimizeRouteResponse,
  RemoveCompaniesRequest,
  RenameListRequest,
  ReorderItemsRequest,
  SetItemDoneRequest,
  UpdateColumnConfigRequest,
  UpdateItemNoteRequest,
} from "../models/index";
import {
  AddCompaniesRequestFromJSON,
  AddCompaniesRequestToJSON,
  BulkSetItemDoneRequestFromJSON,
  BulkSetItemDoneRequestToJSON,
  CompanyListDetailFromJSON,
  CompanyListDetailToJSON,
  CompanyListSummaryFromJSON,
  CompanyListSummaryToJSON,
  CreateListRequestFromJSON,
  CreateListRequestToJSON,
  CreateListResponseFromJSON,
  CreateListResponseToJSON,
  MoveCompaniesRequestFromJSON,
  MoveCompaniesRequestToJSON,
  OptimizeRouteRequestFromJSON,
  OptimizeRouteRequestToJSON,
  OptimizeRouteResponseFromJSON,
  OptimizeRouteResponseToJSON,
  RemoveCompaniesRequestFromJSON,
  RemoveCompaniesRequestToJSON,
  RenameListRequestFromJSON,
  RenameListRequestToJSON,
  ReorderItemsRequestFromJSON,
  ReorderItemsRequestToJSON,
  SetItemDoneRequestFromJSON,
  SetItemDoneRequestToJSON,
  UpdateColumnConfigRequestFromJSON,
  UpdateColumnConfigRequestToJSON,
  UpdateItemNoteRequestFromJSON,
  UpdateItemNoteRequestToJSON,
} from "../models/index";

export interface AddCompaniesOperationRequest {
  addCompaniesRequest: AddCompaniesRequest;
}

export interface BulkSetItemDoneOperationRequest {
  bulkSetItemDoneRequest: BulkSetItemDoneRequest;
}

export interface BulkUndoneRequest {
  companyListId: string;
}

export interface ClearRouteRequest {
  companyListId: string;
}

export interface CreateListOperationRequest {
  createListRequest: CreateListRequest;
}

export interface DeleteListRequest {
  companyListId: string;
}

export interface DuplicateListRequest {
  companyListId: string;
}

export interface FollowListRequest {
  companyListId: string;
}

export interface GetListDetailRequest {
  companyListId: string;
}

export interface MoveCompaniesOperationRequest {
  moveCompaniesRequest: MoveCompaniesRequest;
}

export interface OptimizeRouteOperationRequest {
  optimizeRouteRequest: OptimizeRouteRequest;
}

export interface RemoveCompaniesOperationRequest {
  removeCompaniesRequest: RemoveCompaniesRequest;
}

export interface RenameListOperationRequest {
  renameListRequest: RenameListRequest;
}

export interface ReorderItemsOperationRequest {
  reorderItemsRequest: ReorderItemsRequest;
}

export interface SetItemDoneOperationRequest {
  setItemDoneRequest: SetItemDoneRequest;
}

export interface UnfollowListRequest {
  companyListId: string;
}

export interface UpdateColumnConfigOperationRequest {
  updateColumnConfigRequest: UpdateColumnConfigRequest;
}

export interface UpdateItemNoteOperationRequest {
  updateItemNoteRequest: UpdateItemNoteRequest;
}

/**
 *
 */
export class CompanyListsApi extends runtime.BaseAPI {
  /**
   */
  async addCompaniesRaw(
    requestParameters: AddCompaniesOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["addCompaniesRequest"] == null) {
      throw new runtime.RequiredError(
        "addCompaniesRequest",
        'Required parameter "addCompaniesRequest" was null or undefined when calling addCompanies().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-lists/add-companies`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AddCompaniesRequestToJSON(
          requestParameters["addCompaniesRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async addCompanies(
    requestParameters: AddCompaniesOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.addCompaniesRaw(requestParameters, initOverrides);
  }

  /**
   */
  async bulkSetItemDoneRaw(
    requestParameters: BulkSetItemDoneOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["bulkSetItemDoneRequest"] == null) {
      throw new runtime.RequiredError(
        "bulkSetItemDoneRequest",
        'Required parameter "bulkSetItemDoneRequest" was null or undefined when calling bulkSetItemDone().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-lists/bulk-set-item-done`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: BulkSetItemDoneRequestToJSON(
          requestParameters["bulkSetItemDoneRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async bulkSetItemDone(
    requestParameters: BulkSetItemDoneOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.bulkSetItemDoneRaw(requestParameters, initOverrides);
  }

  /**
   */
  async bulkUndoneRaw(
    requestParameters: BulkUndoneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyListId"] == null) {
      throw new runtime.RequiredError(
        "companyListId",
        'Required parameter "companyListId" was null or undefined when calling bulkUndone().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyListId"] != null) {
      queryParameters["companyListId"] = requestParameters["companyListId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-lists/bulk-undone`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async bulkUndone(
    requestParameters: BulkUndoneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.bulkUndoneRaw(requestParameters, initOverrides);
  }

  /**
   */
  async clearRouteRaw(
    requestParameters: ClearRouteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyListId"] == null) {
      throw new runtime.RequiredError(
        "companyListId",
        'Required parameter "companyListId" was null or undefined when calling clearRoute().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyListId"] != null) {
      queryParameters["companyListId"] = requestParameters["companyListId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-lists/clear-route`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async clearRoute(
    requestParameters: ClearRouteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.clearRouteRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createListRaw(
    requestParameters: CreateListOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateListResponse>> {
    if (requestParameters["createListRequest"] == null) {
      throw new runtime.RequiredError(
        "createListRequest",
        'Required parameter "createListRequest" was null or undefined when calling createList().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-lists/create-list`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateListRequestToJSON(requestParameters["createListRequest"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateListResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async createList(
    requestParameters: CreateListOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateListResponse> {
    const response = await this.createListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async deleteListRaw(
    requestParameters: DeleteListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters["companyListId"] == null) {
      throw new runtime.RequiredError(
        "companyListId",
        'Required parameter "companyListId" was null or undefined when calling deleteList().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyListId"] != null) {
      queryParameters["companyListId"] = requestParameters["companyListId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-lists/delete-list`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async deleteList(
    requestParameters: DeleteListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<boolean> {
    const response = await this.deleteListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async duplicateListRaw(
    requestParameters: DuplicateListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateListResponse>> {
    if (requestParameters["companyListId"] == null) {
      throw new runtime.RequiredError(
        "companyListId",
        'Required parameter "companyListId" was null or undefined when calling duplicateList().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyListId"] != null) {
      queryParameters["companyListId"] = requestParameters["companyListId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-lists/duplicate-list`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateListResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async duplicateList(
    requestParameters: DuplicateListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateListResponse> {
    const response = await this.duplicateListRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async followListRaw(
    requestParameters: FollowListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyListId"] == null) {
      throw new runtime.RequiredError(
        "companyListId",
        'Required parameter "companyListId" was null or undefined when calling followList().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyListId"] != null) {
      queryParameters["companyListId"] = requestParameters["companyListId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-lists/follow-list`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async followList(
    requestParameters: FollowListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.followListRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getAllListsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CompanyListSummary>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-lists/get-all-lists`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyListSummaryFromJSON),
    );
  }

  /**
   */
  async getAllLists(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CompanyListSummary>> {
    const response = await this.getAllListsRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getListDetailRaw(
    requestParameters: GetListDetailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CompanyListDetail>> {
    if (requestParameters["companyListId"] == null) {
      throw new runtime.RequiredError(
        "companyListId",
        'Required parameter "companyListId" was null or undefined when calling getListDetail().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyListId"] != null) {
      queryParameters["companyListId"] = requestParameters["companyListId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-lists/get-list-detail`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyListDetailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getListDetail(
    requestParameters: GetListDetailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CompanyListDetail> {
    const response = await this.getListDetailRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async moveCompaniesRaw(
    requestParameters: MoveCompaniesOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["moveCompaniesRequest"] == null) {
      throw new runtime.RequiredError(
        "moveCompaniesRequest",
        'Required parameter "moveCompaniesRequest" was null or undefined when calling moveCompanies().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-lists/move-companies`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: MoveCompaniesRequestToJSON(
          requestParameters["moveCompaniesRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async moveCompanies(
    requestParameters: MoveCompaniesOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.moveCompaniesRaw(requestParameters, initOverrides);
  }

  /**
   */
  async optimizeRouteRaw(
    requestParameters: OptimizeRouteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OptimizeRouteResponse>> {
    if (requestParameters["optimizeRouteRequest"] == null) {
      throw new runtime.RequiredError(
        "optimizeRouteRequest",
        'Required parameter "optimizeRouteRequest" was null or undefined when calling optimizeRoute().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-lists/optimize-route`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: OptimizeRouteRequestToJSON(
          requestParameters["optimizeRouteRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OptimizeRouteResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async optimizeRoute(
    requestParameters: OptimizeRouteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OptimizeRouteResponse> {
    const response = await this.optimizeRouteRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async removeCompaniesRaw(
    requestParameters: RemoveCompaniesOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["removeCompaniesRequest"] == null) {
      throw new runtime.RequiredError(
        "removeCompaniesRequest",
        'Required parameter "removeCompaniesRequest" was null or undefined when calling removeCompanies().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-lists/remove-companies`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: RemoveCompaniesRequestToJSON(
          requestParameters["removeCompaniesRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async removeCompanies(
    requestParameters: RemoveCompaniesOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.removeCompaniesRaw(requestParameters, initOverrides);
  }

  /**
   */
  async renameListRaw(
    requestParameters: RenameListOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["renameListRequest"] == null) {
      throw new runtime.RequiredError(
        "renameListRequest",
        'Required parameter "renameListRequest" was null or undefined when calling renameList().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-lists/rename-list`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: RenameListRequestToJSON(requestParameters["renameListRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async renameList(
    requestParameters: RenameListOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.renameListRaw(requestParameters, initOverrides);
  }

  /**
   */
  async reorderItemsRaw(
    requestParameters: ReorderItemsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["reorderItemsRequest"] == null) {
      throw new runtime.RequiredError(
        "reorderItemsRequest",
        'Required parameter "reorderItemsRequest" was null or undefined when calling reorderItems().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-lists/reorder-items`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ReorderItemsRequestToJSON(
          requestParameters["reorderItemsRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async reorderItems(
    requestParameters: ReorderItemsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.reorderItemsRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setItemDoneRaw(
    requestParameters: SetItemDoneOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["setItemDoneRequest"] == null) {
      throw new runtime.RequiredError(
        "setItemDoneRequest",
        'Required parameter "setItemDoneRequest" was null or undefined when calling setItemDone().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-lists/set-item-done`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SetItemDoneRequestToJSON(requestParameters["setItemDoneRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setItemDone(
    requestParameters: SetItemDoneOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setItemDoneRaw(requestParameters, initOverrides);
  }

  /**
   */
  async unfollowListRaw(
    requestParameters: UnfollowListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyListId"] == null) {
      throw new runtime.RequiredError(
        "companyListId",
        'Required parameter "companyListId" was null or undefined when calling unfollowList().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyListId"] != null) {
      queryParameters["companyListId"] = requestParameters["companyListId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-lists/unfollow-list`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async unfollowList(
    requestParameters: UnfollowListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.unfollowListRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateColumnConfigRaw(
    requestParameters: UpdateColumnConfigOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["updateColumnConfigRequest"] == null) {
      throw new runtime.RequiredError(
        "updateColumnConfigRequest",
        'Required parameter "updateColumnConfigRequest" was null or undefined when calling updateColumnConfig().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-lists/update-column-config`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateColumnConfigRequestToJSON(
          requestParameters["updateColumnConfigRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateColumnConfig(
    requestParameters: UpdateColumnConfigOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateColumnConfigRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateItemNoteRaw(
    requestParameters: UpdateItemNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["updateItemNoteRequest"] == null) {
      throw new runtime.RequiredError(
        "updateItemNoteRequest",
        'Required parameter "updateItemNoteRequest" was null or undefined when calling updateItemNote().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-lists/update-item-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateItemNoteRequestToJSON(
          requestParameters["updateItemNoteRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateItemNote(
    requestParameters: UpdateItemNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateItemNoteRaw(requestParameters, initOverrides);
  }
}
